var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wine_svg__clip0)",
    fill: "#91C300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.326 3.132a1.316 1.316 0 000-2.632h-.007c-.727 0-1.312.59-1.312 1.316a1.32 1.32 0 001.32 1.316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.501 14.27L24.398 1.108A1.316 1.316 0 0023.098 0h-3.864a1.316 1.316 0 000 2.632h2.742l1.511 9.454c-2.78 1.469-6.89 1.324-9.407-.436-2.928-2.047-7.175-2.465-10.644-1.257l1.24-7.761h2.742a1.316 1.316 0 000-2.632H3.554c-.647 0-1.198.47-1.3 1.108L.152 14.27c-.553 3.457.424 6.862 2.75 9.59a13.935 13.935 0 009.11 4.775v9.706L5.274 43.66c-1.226.967-1.725 2.58-1.242 4.012.483 1.434 1.84 2.344 3.544 2.375H19.05a.96.96 0 00.024 0c1.704-.03 3.062-.94 3.545-2.375.482-1.432-.017-3.045-1.242-4.012l-6.736-5.32v-9.705a13.937 13.937 0 009.11-4.776c2.326-2.727 3.302-6.132 2.75-9.589zm-6.754 31.455c.408.322.482.8.379 1.107-.157.465-.676.575-1.088.584H7.614c-.412-.01-.93-.119-1.088-.584-.103-.307-.029-.785.38-1.107l6.42-5.07 6.42 5.07zm2.002-23.574c-2.063 2.418-5.287 3.92-8.418 3.92h-.011c-3.13 0-6.354-1.502-8.417-3.92-1.818-2.13-2.583-4.782-2.153-7.466l.19-1.187c2.778-1.602 7.046-1.5 9.632.309 1.843 1.288 4.207 1.932 6.571 1.932 1.651 0 3.301-.315 4.774-.943.391 2.646-.375 5.254-2.168 7.355z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wine_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h26.71v50H0z"
  })))));
}

export default SvgWine;